/* eslint @typescript-eslint/no-explicit-any: 0 */
export default (x, fs) => fs.reduce((v, f) => f(v), x);
//# sourceMappingURL=doPipe.mjs.map